const PERMISSION_KEY = "core:tenant_webhook";
const PAGE_URL = {
    TENANT_WEBHOOK_PAGE: "/admin/core/tenant-webhook"
}

export {PERMISSION_KEY, PAGE_URL}

